import React, { Component } from "react";
import "./left-sidebar.css"; // import the CSS file
import Shop from "./shop";
import { Link } from "react-router-dom";
class FixedSidebar extends Component {
  render() {
    return (
      <div className="fixed-sidebar">
        <Shop />
        <div
          style={{
            position: "fixed",
            bottom: 0,
            left: 0,
            padding: 15,
            background: "white",
            width: "14vw",
            marginLeft: 6,
            marginBottom: 10,
            borderRadius: 5,
            boxShadow: "0 6px 16px rgba(255, 126, 95, 0.4)",
            cursor: "pointer",
          }}
        >
          <Link
            to={`/pages/request-for-product`}
            style={{ color: "#ec345b", fontWeight: "bold" }}
          >
            Request a Product
          </Link>
        </div>
      </div>
    );
  }
}

export default FixedSidebar;
